import React from 'react';
import { Color, setColor } from 'src/styles/colors';

interface IconsCallToActionArrowProps {
  color?: Color;
  width?: number;
}

const IconsCallToActionArrow = ({ color = 'greyText', width = 15 }: IconsCallToActionArrowProps): JSX.Element => {
  return (
    <svg
      width={width}
      viewBox='0 0 15 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.0233 5.34781C14.2515 5.11958 14.2515 4.74955 14.0233 4.52132L10.3041 0.802127C10.0759 0.573898 9.70586 0.573898 9.47763 0.802127C9.2494 1.03036 9.2494 1.40039 9.47763 1.62862L12.7836 4.93457L9.47763 8.24052C9.2494 8.46875 9.2494 8.83878 9.47763 9.06701C9.70586 9.29524 10.0759 9.29524 10.3041 9.06701L14.0233 5.34781ZM0.75293 5.51899L13.6101 5.51898L13.6101 4.35015L0.75293 4.35015L0.75293 5.51899Z'
        fill={setColor(color)}
      />
    </svg>
  );
};

export default IconsCallToActionArrow;
